module.exports = __webpack_public_path__ + "static/media/negotiation-inactive.7dc2039d.svg";